import { ChannelTemplateCategory } from "./channel-template-category";
import { ChannelTemplate } from "./channel-template";

export abstract class ChannelTemplateRepository {
  getAllChannelTemplateCategories: () => Promise<
    Array<ChannelTemplateCategory>
  >;
  getAllTemplates: () => Promise<Array<ChannelTemplate>>;
}
